import { storageManager } from '~/shared/lib/storage-manager'

const STORAGE_KEY = 'pulsify.device-id'

let cached: string | null = null

/** Stable UUID per browser. Created on first call, persisted to localStorage. */
export function getDeviceId(): string {
  if (cached) return cached

  const existing = storageManager.get<string>(STORAGE_KEY)
  if (existing) {
    cached = existing
    return existing
  }

  const fresh = crypto.randomUUID()
  storageManager.set(STORAGE_KEY, fresh)
  cached = fresh
  return fresh
}
